"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentCode = void 0;
/**
 * An enumeration.
 */
var PaymentCode;
(function (PaymentCode) {
    PaymentCode["UNKNOWN"] = "??";
    PaymentCode["PAXUM"] = "PX";
    PaymentCode["INTERCASH"] = "IC";
    PaymentCode["EPSERV"] = "PS";
    PaymentCode["MASSPAY"] = "MP";
    PaymentCode["NOTCOMPLETED"] = "NC";
    PaymentCode["SCREENNAME"] = "CC";
    PaymentCode["WEBMONEY"] = "WM";
    PaymentCode["BANK_TRANSFER"] = "BT";
    PaymentCode["FIRSTCHOICEPAY"] = "PR";
    PaymentCode["EPAYMENTS"] = "EX";
    PaymentCode["EPASSPORTE"] = "EP";
    PaymentCode["CHECK"] = "CA";
    PaymentCode["WESTERN_UNION"] = "WU";
})(PaymentCode = exports.PaymentCode || (exports.PaymentCode = {}));
